import React, { useEffect } from 'react';
import ImageSlider from '../components/ImageSlider';
import Header from '../components/Header';
import ContactUs from '../components/ContactUs';

const brickSlides = [
  'bricks-photos/IMG_0641.jpg',
  'bricks-photos/IMG_2749.jpg',
  'bricks-photos/IMG_6106.jpg',
  'bricks-photos/IMG_6166.jpg',
  'bricks-photos/IMG_2750.jpg',
  'bricks-photos/IMG_6506.jpg',
];

function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
}

function GalleryPage() {
  useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <div class='bg-[#fafafa]'>
      <Header />
      <div className='h-auto bg-[#2b2b2b] flex items-center justify-center py-10'>
        <h1 className='text-[#fafafa] text-6xl px-4'>Showcase of Our Craftsmanship</h1>
      </div>
      <div className='h-auto mx-4 sm:mx-8 lg:mx-16 my-8 lg:my-16 border-y-4 border-[#2b2b2b]'>
        
        <h2 className=' px-5 py-10 text-sm sm:text-base md:text-lg lg:text-xl'>
          Explore our gallery to witness the exceptional craftsmanship and
          quality that define our services. Each image in this collection
          captures the dedication and skill we bring to every project,
          reflecting our commitment to excellence in the construction and
          restoration industry. 
        </h2>
        {/* <h2 className=' pt-5 text-sm sm:text-base md:text-lg lg:text-xl'>Our expertise ensures not only aesthetic appeal
          but also lasting durability and functionality. From intricate details
          to large-scale undertakings, our work speaks for itself, demonstrating
          the high standards and meticulous attention to detail that our clients
          have come to expect. We take pride in transforming spaces and
          delivering results that stand the test of time.</h2> */}
      </div>
      <div className='space-y-8 mb-16'>
        <ImageSlider
          service='Masonry and Brick'
          link='/masonryandbrick'
          imageArray={brickSlides}
        />
        <ImageSlider service='Caulking and Sealant' link='/caulking' imageArray={brickSlides} />
        <ImageSlider
          service='Concrete Repairs/Balcony Restoration'
          link='/concrete'
          imageArray={brickSlides}
        />
        <ImageSlider service='Waterproofing' link='/waterproofing' imageArray={brickSlides} />
        <ImageSlider service='Painting' link='/painting' imageArray={brickSlides} />
        <ImageSlider service='EIFS/Stucco' link='/eifsstucco' imageArray={brickSlides} />
      </div>
      <ContactUs />
    </div>
  );
}

export default GalleryPage;
